export default __webpack_public_path__ + "static/media/rheinerft1_light.09f4e9c9.png";